import React, { FunctionComponent, useContext, useEffect } from 'react'
import { Route, useHistory, useRouteMatch } from 'react-router-dom'
import { ReduxContext } from '../redux/Store'

const PrivateRoute: FunctionComponent<any> = ({ component: Component, ...rest }) => {
    const history = useHistory()
    const { isExact } = useRouteMatch()

    const {
        selectors: { user, userId },
    } = useContext(ReduxContext)

    useEffect(() => {
        if (isExact) {
            if (user !== null && !userId) {
                history.push('/logout')
            }

            if (user && !user?.emailVerified) {
                history.push('/register/confirmation')
            }
        }
    }, [userId, user, history, isExact])

    return <Route {...rest} render={props => <Component {...props} />} />
}

export { PrivateRoute }
